import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 8C21.7614 8 24 10.2386 24 13C24 15.6888 21.8777 17.8818 19.2169 17.9954L19 18C19 20.7614 16.7614 23 14 23H6C3.23858 23 1 20.7614 1 18V9C1 8.44772 1.44772 8 2 8H19ZM17 10H3V18C3 19.5977 4.24892 20.9037 5.82373 20.9949L6 21H14C15.6569 21 17 19.6569 17 18V10ZM19 10V16C20.6569 16 22 14.6569 22 13C22 11.4023 20.7511 10.0963 19.1763 10.0051L19 10ZM6 1C6.51284 1 6.93551 1.38604 6.99327 1.88338L7 2V5C7 5.55228 6.55228 6 6 6C5.48716 6 5.06449 5.61396 5.00673 5.11662L5 5V2C5 1.44772 5.44772 1 6 1ZM10 1C10.5128 1 10.9355 1.38604 10.9933 1.88338L11 2V5C11 5.55228 10.5523 6 10 6C9.48716 6 9.06449 5.61396 9.00673 5.11662L9 5V2C9 1.44772 9.44771 1 10 1ZM14 1C14.5128 1 14.9355 1.38604 14.9933 1.88338L15 2V5C15 5.55228 14.5523 6 14 6C13.4872 6 13.0645 5.61396 13.0067 5.11662L13 5V2C13 1.44772 13.4477 1 14 1Z"
        fill="#191919"
      />
    </Svg>
  );
};

export default Icon;
